const COUNTRIES_WITH_PROVIDER = [
    {
        provider: 'scopesi',
        countries: ['AR'],
    },
    {
        provider: 'onemata',
        countries: ['ZA', 'CL', 'MX', 'CO', 'AE'],
    },
    {
        provider: 'cinnecta',
        countries: ['BR'],
    },
];

const COUNTRIES_OF_PROVIDERS = [
    {
        provider: ['scopesi', 'onemata'],
        countries: ['AR', 'PY'],
    },
    {
        provider: ['onemata'],
        countries: [
            'CL',
            'CO',
            'MX',
            'CR',
            'PA',
            'SV',
            'GT',
            'HN',
            'EC',
            'DO',
            'ES',
            'BR',
            'UY',
            'PE',
            'AE',
        ],
    },
    {
        provider: ['scopesi'],
        countries: ['PE'],
    },
    {
        provider: ['cinnecta'],
        countries: ['BR'],
    },
];

const COUNTRIES_WITH_TIMEZONES = [
    {
        value: 'TR',
        label: 'Turkey',
        timezone: +3,
    },
    {
        value: 'MX',
        label: 'Mexico',
        timezone: -6,
    },
    {
        value: 'MY',
        label: 'Malaysia',
        timezone: +8,
    },
    {
        value: 'AR',
        label: 'Argentina',
        timezone: -3,
    },
    {
        value: 'UY',
        label: 'Uruguay',
        timezone: -3,
    },
    {
        value: 'PY',
        label: 'Paraguay',
        timezone: -3,
    },
    {
        value: 'ES',
        label: 'Spain',
        timezone: +1,
    },
    {
        value: 'PT',
        label: 'Portugal',
        timezone: 0,
    },
    {
        value: 'MX',
        label: 'Mexico',
        timezone: -7,
    },
    {
        value: 'PE',
        label: 'Peru',
        timezone: -5,
    },
    {
        value: 'CL',
        label: 'Chile',
        timezone: -5,
    },
    {
        value: 'IN',
        label: 'India',
        timezone: +5.3,
    },
    {
        value: 'BR',
        label: 'Brazil',
        timezone: -3,
    },
    {
        value: 'ZA',
        label: 'South Africa',
        timezone: +2,
    },
    {
        value: 'CO',
        label: 'Colombia',
        timezone: -5,
    },
    {
        value: 'AE',
        label: 'Emirates Arabes Unidos',
        timezone: +4,
    },
];

const COUNTRY_CURRENCY_NAME = {
    USD: 'US',
    ARS: 'AR',
    EUR: 'EU',
    MXN: 'MX',
    CLP: 'CL',
    INR: 'IN',
    PEN: 'PE',
    BRL: 'BR',
    ZAR: 'ZA',
    PYG: 'PY',
    COP: 'CO',
};

const STRATEGY_TO_SCHEDULER_MODE = {
    evenly: 1,
    asap: 2,
    exlusivity: 3,
    optimizer: 4,
    viooh_distribution: 5,
};

const SCHEDULER_MODE_TO_STRATEGY = {
    1: 'evenly',
    2: 'asap',
    3: 'exlusivity',
    4: 'optimizer',
    5: 'viooh_distribution',
};

const CAMPAIGN_PROPOSALS_STATUSES = ['draft', 'archived', 'sent'];

// Edición de impactos esperados (expectedStats) oculta temporalmente (TGF-1526).
// Poner en true para volver a mostrarla en el wizard y en el dashboard.
const EXPECTED_STATS_UI_ENABLED = false;

module.exports = {
    COUNTRIES_WITH_PROVIDER,
    COUNTRIES_WITH_TIMEZONES,
    COUNTRY_CURRENCY_NAME,
    COUNTRIES_OF_PROVIDERS,
    CAMPAIGN_PROPOSALS_STATUSES,
    STRATEGY_TO_SCHEDULER_MODE,
    SCHEDULER_MODE_TO_STRATEGY,
    EXPECTED_STATS_UI_ENABLED,
};
